<template>
  <div class="OAOperationButton">
    <template v-for="(item, index) in bind">
      <div
        :key="index"
        v-if="!(item.disabled && item.disabled(scope))"
        @click="click(item.click)"
      >
        <span v-if="item.jurisdiction" v-permission="item.jurisdiction">{{ item.text }}</span>
        <span v-else>{{ item.text }}</span>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "OAOperationButton",
  props: {
    bind: {
      type: Array,
      default: () => []
    },
    scope: {
      type: Object,
      default: {}
    }
  },
  methods: {
    click(fn) {
      if (Object.prototype.toString.call(fn) === "[object Function]") {
        fn(this.scope);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/OAOperationButton/OAOperationButton.vue